export default class Accordion {
	constructor(root) {
		this.root = root;
		this.name = root?.getAttribute('data-name');
		this.items = root?.querySelectorAll('.accordion-item');

		this.items.forEach((item) => {
			const btn = item.querySelector('button[aria-controls]');
			const nextBtn = item.querySelector('.accordion-next');

			btn.addEventListener('click', () => {
				const expanded = btn.getAttribute('aria-expanded') === 'true';
				this[expanded ? 'closeItem' : 'openItem'](item);
			});

			nextBtn?.addEventListener('click', () => {
				const nextItem = item.nextElementSibling;
				this.openItem(nextItem);
			});
		});
	}

	/**
	 * Collapse all items
	 */
	collapse() {
		this.items.forEach((item) => {
			this.closeItem(item);
		});
	}

	/**
	 * Open a single item
	 *
	 * @param {HTMLElement} el The item to open
	 */
	openItem(el) {
		// Close all items first
		this.collapse();

		const btn = el?.querySelector('button[aria-controls]');
		btn?.setAttribute('aria-expanded', 'true');
		this.root.setAttribute('data-value', el.getAttribute('data-value'));

		setTimeout(() => {
			this.scrollToTop(el);
		}, 150);
	}

	/**
	 * Scroll to the top of an accordion item
	 *
	 * @param {HTMLElement} el The accordion item element
	 */
	scrollToTop(el) {
		// Use requestAnimationFrame to ensure the DOM has updated
		requestAnimationFrame(() => {
			const yOffset = -150; // Offset to account for fixed headers
			const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
			window.scrollTo({ top: y, behavior: 'smooth' });
		});
	}

	/**
	 * Close a single item
	 *
	 * @param {HTMLElement} el The item to close
	 */
	closeItem(el) {
		this.root.removeAttribute('data-value');
		const btn = el?.querySelector('button[aria-controls]');
		btn?.setAttribute('aria-expanded', 'false');
	}
}
